import React from 'react';

export const CustomThemePalette = ({ styles }: { styles: string }) => (
  <style
    dangerouslySetInnerHTML={{
      // на WL всегда светлая тема
      __html: styles,
    }}
  />
);
